import './App.css';

const features = [
  {
    title: 'Agenda y registro en minutos',
    description:
      'Crea landing, formulario y recordatorios sin tocar código. Solo define fecha, cupos y quienes deben recibir alertas.',
    tag: 'Automatización',
  },
  {
    title: 'Convierte a tu comunidad',
    description:
      'Links cortos, QR y recordatorios por correo/WhatsApp para que nadie olvide asistir. Sin fricción, sin descargas.',
    tag: 'Conversión',
  },
  {
    title: 'Mide impacto en vivo',
    description:
      'Reportes en tiempo real de confirmados, check-ins y no shows. Exporta los datos y comparte resúmenes con tu equipo.',
    tag: 'Analítica',
  },
  {
    title: 'Escala tu operación',
    description:
      'Duplicar eventos, clonar agendas y reutilizar plantillas de comunicación para equipos grandes o agencias.',
    tag: 'Operaciones',
  },
];

const steps = [
  {
    title: 'Diseña la experiencia',
    description: 'Define propósito, agenda, ponentes y beneficios. ShowUp genera la landing y el registro por ti.',
  },
  {
    title: 'Activa a tu audiencia',
    description: 'Comparte un solo enlace, integra calendario y envía recordatorios automáticos.',
  },
  {
    title: 'Mide y optimiza',
    description: 'Monitorea confirmaciones, asistencia y feedback para iterar el siguiente evento.',
  },
];

function App() {
  return (
    <div className="page">
      <div className="glow blur-1" />
      <div className="glow blur-2" />

      <nav className="nav">
        <div className="brand">
          <div className="brand-mark">SU</div>
          <span className="brand-name">ShowUp</span>
        </div>
        <div className="nav-actions">
          <button className="btn ghost">Ver demo</button>
          <button className="btn primary">Crear evento</button>
        </div>
      </nav>

      <main className="content">
        <header className="hero">
          <div className="eyebrow">Eventos • Workshops • Comunidades</div>
          <h1>
            La forma rápida de lanzar, recordar y llenar tus eventos con ShowUp.
          </h1>
          <p className="lede">
            Todo en un solo lugar: landing, registros, recordatorios y analítica. Diseñado para equipos que
            necesitan ejecutar y medir sin depender de múltiples herramientas.
          </p>
          <div className="hero-actions">
            <button className="btn primary large">Probar gratis</button>
            <button className="btn outline large">Hablar con nosotros</button>
          </div>
          <div className="hero-meta">
            <div>
              <span className="meta-label">Tasa de show-up</span>
              <strong>+18% promedio</strong>
            </div>
            <div>
              <span className="meta-label">Tiempo de lanzamiento</span>
              <strong>&lt; 15 minutos</strong>
            </div>
            <div>
              <span className="meta-label">Integraciones</span>
              <strong>Calendario · Stripe · WhatsApp</strong>
            </div>
          </div>
        </header>

        <section className="section">
          <div className="section-header">
            <p className="eyebrow">Beneficios clave</p>
            <h2>Ahorra tiempo y aumenta la asistencia de tu audiencia.</h2>
            <p className="section-lede">
              ShowUp combina lo esencial: diseño de landing, gestión de registro, comunicación automática y métricas
              claras para que tu evento brille.
            </p>
          </div>
          <div className="grid">
            {features.map((feature) => (
              <article key={feature.title} className="card">
                <span className="chip">{feature.tag}</span>
                <h3>{feature.title}</h3>
                <p>{feature.description}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="section steps">
          <div className="section-header">
            <p className="eyebrow">Cómo funciona</p>
            <h2>De la idea al evento en tres pasos.</h2>
          </div>
          <div className="step-list">
            {steps.map((step, index) => (
              <div key={step.title} className="step-card">
                <div className="step-number">0{index + 1}</div>
                <div>
                  <h3>{step.title}</h3>
                  <p>{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="section cta">
          <div>
            <p className="eyebrow">Prueba gratuita</p>
            <h2>Tu próxima sesión puede estar lista hoy.</h2>
            <p className="section-lede">
              Configura un evento de prueba, invita a tu equipo y mide la experiencia end-to-end con ShowUp.
            </p>
          </div>
          <div className="cta-actions">
            <button className="btn primary large">Crear evento</button>
            <button className="btn outline large">Solicitar demo</button>
          </div>
        </section>
      </main>

      <footer className="footer">
        <div className="brand">
          <div className="brand-mark">SU</div>
          <span className="brand-name">ShowUp</span>
        </div>
        <p>Planifica, recuerda y llena cada evento. © {new Date().getFullYear()} ShowUp.</p>
      </footer>
    </div>
  );
}

export default App;
